import { useQuery } from "@tanstack/react-query"
import { shopifyIntegrationQuery } from "../../lib/shopify/shopifyIntegrationQuery"

export function useShopifyIntegrationQuery(...args: Parameters<typeof shopifyIntegrationQuery>) {
  return useQuery(shopifyIntegrationQuery(...args))
}
